// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dg4YM","clinicsSelect":"styles_clinicsSelect__3ucQ-"};